module.exports = __webpack_public_path__ + "static/media/GQ.79b46cc7.png";